import { render } from "./EquipementTemperatures.vue?vue&type=template&id=9ecd2d60&ts=true"
import script from "./EquipementTemperatures.vue?vue&type=script&lang=ts"
export * from "./EquipementTemperatures.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__